import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { VimeoUnavailablePlaceholderSize } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo-enum';
import { IChatConversationMessage } from '@fi-shared/fi-chat/fi-chat';
import { FiContenteditableComponent } from '@fi-shared/fi-contenteditable/fi-contenteditable.component';
import { FiReplaceLinkTypes } from '@fi-shared/fi-directives/replace-with-links/replace-with-links.directive';
import { FiInsertMedia2Service } from '@fi-shared/fi-insert-media/fi-insert-media2.service';
import { DetectDevicesService } from '@fi-shared/fi-shared-services/detect-devices.service';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { FiImageSize, ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-message-editor',
    templateUrl: './message-editor.component.html',
    styleUrls: ['./message-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-message-editor' },
    standalone: false,
})
export class FiMessageEditorComponent {
    @Input() conversationMessage: IChatConversationMessage;
    @Output() conversationMessageChange = new EventEmitter<IChatConversationMessage>();

    @Input() isDisabled: boolean = false;
    @Output() cancelEditing = new EventEmitter<void>();
    @Output() onEnterKeyPressed = new EventEmitter<void>();

    @ViewChild('fiContenteditableComponent', { static: true })
    fiContenteditableComponent: FiContenteditableComponent;
    protected readonly ImageSizes = FiImageSize;
    protected readonly VimeoUnavailablePlaceholderSize = VimeoUnavailablePlaceholderSize;

    protected readonly replaceLinkTypes: FiReplaceLinkTypes[] = [FiReplaceLinkTypes.Url, FiReplaceLinkTypes.Email];

    constructor(
        private fiInsertMedia2Service: FiInsertMedia2Service,
        private detectDeviceService: DetectDevicesService,
        private cdr: ChangeDetectorRef,
    ) {}

    public detectChanges(): void {
        this.cdr.markForCheck();
    }

    protected onFilesPasted($event: File[]): void {
        this.fiInsertMedia2Service
            .onFilePasted($event, ObjectTypes.ChatConversationMessage)
            .then((mediaBankFileReferences: IMediaBankFileReference[]) => {
                this.conversationMessage.MediaBankFileReferences = [
                    ...this.conversationMessage.MediaBankFileReferences,
                    ...mediaBankFileReferences,
                ];
                this.detectChanges();
                this.contentChanged();
            });
    }

    protected handleEnterKeyPress($event: Event): void {
        if (this.detectDeviceService.isMobilePhone()) return;

        $event.preventDefault();
        this.onEnterKeyPressed.emit();
    }

    protected onMediaBankFileReferenceChange($event: IMediaBankFileReference[]): void {
        this.conversationMessage.MediaBankFileReferences = $event;
        this.contentChanged();
    }

    protected contentChanged(): void {
        this.conversationMessageChange.emit(this.conversationMessage);
    }
}
